/* Advertorial CTA tracking v1. Consent is supplied by Shopify, never inferred. */
(function () {
  'use strict';
  if (window.__advertorialCTATracking) return;
  var config = document.querySelector('[data-advertorial-tracking-config]');
  if (!config) return;
  var settings = JSON.parse(config.textContent);
  var scope = (settings.template + ' ' + settings.page).toLowerCase();
  if (/quiz|calculator|daily-vital|health-signal|contact|privacy|terms|refund/.test(scope)) return;
  config.setAttribute('data-tracking-loaded', 'true');
  var state = window.__advertorialCTATracking = {version: '2.0.0', eligible: 0, sent: 0};
  var pixel = '3189260324703056', initialized = false, viewed = false;
  var selector = '[data-advertorial-cta],[data-cta-placement],[data-cta-location],.purchase,.buy,.sticky-buy,.cta,.cta-btn,.cta-btn-full,.cta-primary,.reason-cta,.cta-button,.pricing-cta,.cw-cta-button,.cw-pricing-cta,.cw-text-cta,.cw-cta-btn,.product-cta,.btn-primary,.hume-cta,.hh-cta,.hh-offer-inner,.vy-btn,.vy-sidebar-cta,.vy-verdict-cta,.vy-mobile-sticky-cta__button,.hbddl__cta';
  function allowed(kind) {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    config.setAttribute('data-consent-api', p ? typeof p[kind] : 'missing');
    try { return !!(p && p[kind] && p[kind]()); } catch (_) { return false; }
  }
  function eligible(a) {
    if (!a || a.closest('nav,footer,cite,.sources,#sources,[data-no-advertorial-tracking]')) return false;
    var url;
    try { url = new URL(a.href, location.href); } catch (_) { return false; }
    if (!/^https?:$/.test(url.protocol) || url.hostname === location.hostname) return false;
    if (/privacy|terms|refund|contact|warranty|\.pdf$/.test(url.pathname)) return false;
    // Only product destinations qualify, not an ordinary outbound article or brand logo.
    var destination = url.pathname;
    if (/^\/discount\//.test(destination)) destination = url.searchParams.get('redirect') || '';
    var productPath = /\/(products?|cart|checkout)(\/|$)/i.test(destination) || /\/pages\/(pdp\d*|hume-body-pod|hume-pod|hume-band[^/]*)(\/|$)/i.test(destination);
    if (!productPath) return false;
    return a.matches(selector) || /check (availability|today|price)|get (the |your )?(hume|offer)|shop now|buy now|claim (the |your )?offer/i.test(a.textContent) || (!!a.querySelector('img') && !a.closest('header,[role="banner"]'));
  }
  function anchors() { return Array.prototype.filter.call(document.querySelectorAll('a[href]'), eligible); }
  function ensurePixel() {
    if (!allowed('marketingAllowed')) return false;
    if (!window.fbq) {
      var n = window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!window._fbq) window._fbq = n;
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
      var s = document.createElement('script'); s.async = true; s.src = 'https://connect.facebook.net/en_US/fbevents.js'; document.head.appendChild(s);
    }
    if (!initialized) {
      var found = false;
      try { found = window.fbq.getState().pixels.some(function (p) { return String(p.id) === pixel; }); } catch (_) {}
      var q = window.fbq.queue || [];
      for (var i = 0; i < q.length; i++) if (q[i][0] === 'init' && String(q[i][1]) === pixel) found = true;
      if (!found) window.fbq('init', pixel);
      initialized = true;
    }
    return true;
  }
  function analytics(name, data) {
    if (!allowed('analyticsProcessingAllowed')) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({event:name}, data));
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data);
  }
  function consentControl() {
    if (document.querySelector('[data-advertorial-cookie-preferences]')) return;
    var footer = document.querySelector('footer') || document.body;
    var button = document.createElement('button');
    button.type = 'button'; button.textContent = 'Cookie preferences';
    button.setAttribute('data-advertorial-cookie-preferences', '');
    button.style.cssText = 'display:block;margin:16px auto;padding:8px 12px;background:transparent;color:inherit;border:1px solid currentColor;border-radius:4px;font:inherit;cursor:pointer';
    footer.appendChild(button);
    button.addEventListener('click', function () {
      var privacy = window.Shopify && Shopify.customerPrivacy;
      if (!privacy || !privacy.setTrackingConsent) return;
      var dialog = document.createElement('dialog');
      dialog.style.cssText = 'max-width:420px;width:calc(100% - 48px);padding:24px;border:1px solid #ccc;border-radius:8px;color:#222;background:#fff;font:16px/1.5 system-ui;z-index:2147483647';
      dialog.setAttribute('aria-labelledby','advertorial-cookie-title');
      dialog.innerHTML = '<h2 id="advertorial-cookie-title" style="font:700 22px/1.3 system-ui;margin:0 0 12px">Cookie preferences</h2><p>We and our partners, including Shopify and Meta, use cookies for analytics and advertising when you allow them. Essential cookies stay enabled.</p><label style="display:block;margin:12px 0"><input type="checkbox" name="analytics"> Allow analytics cookies</label><label style="display:block;margin:12px 0"><input type="checkbox" name="marketing"> Allow advertising cookies (including Meta)</label><p role="status"></p><button type="button" data-save style="padding:10px;margin-right:12px">Save preferences</button><button type="button" data-cancel style="padding:10px">Cancel</button>';
      dialog.querySelector('[name="analytics"]').checked = allowed('analyticsProcessingAllowed');
      dialog.querySelector('[name="marketing"]').checked = allowed('marketingAllowed');
      dialog.querySelector('[data-cancel]').onclick = function () { dialog.close(); };
      dialog.addEventListener('close', function () { dialog.remove(); button.focus(); });
      dialog.querySelector('[data-save]').onclick = function () {
        privacy.setTrackingConsent({analytics:dialog.querySelector('[name="analytics"]').checked, marketing:dialog.querySelector('[name="marketing"]').checked}, function (result) {
          if (result && result.error) { dialog.querySelector('[role="status"]').textContent = 'Could not save your preferences. Please try again.'; return; }
          ready(); dialog.close();
        });
      };
      document.body.appendChild(dialog); dialog.showModal();
    });
  }
  function ready() {
    var list = anchors(); state.eligible = list.length; config.setAttribute('data-eligible-ctas', String(list.length)); config.setAttribute('data-marketing-allowed', String(allowed('marketingAllowed')));
    if (!list.length) return;
    consentControl();
    ensurePixel();
    if (!viewed && allowed('analyticsProcessingAllowed')) {
      viewed = true; analytics('advertorial_view', {publisher:settings.publisher, advertorial_id:settings.page});
    }
  }
  function onClick(e) {
    if (e.type === 'auxclick' ? e.button !== 1 : e.button !== 0) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!eligible(a)) return;
    var url = new URL(a.href, location.href);
    var position = a.getAttribute('data-cta-placement') || a.getAttribute('data-cta-location');
    if (!position) position = a.closest('[class*="sticky"]') ? 'sticky' : 'inline_' + (anchors().indexOf(a) + 1);
    var product = a.getAttribute('data-product') || (/band/i.test(url.pathname + (url.searchParams.get('redirect') || '')) ? 'hume_band' : /humehealth\.com$/.test(url.hostname) ? 'hume_pod' : url.pathname.split('/').filter(Boolean).pop());
    var data = {conversion_type:'advertorial_cta_click', publisher:settings.publisher, advertorial_id:settings.page, product:product, cta_position:position};
    if (ensurePixel()) { window.fbq('trackSingleCustom', pixel, 'CTA Click', {}); state.sent++; config.setAttribute('data-events-sent', String(state.sent)); }
    analytics('advertorial_cta_click', data);
  }
  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);
  document.addEventListener('visitorConsentCollected', ready);
  if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function (error) { config.setAttribute('data-consent-load', error ? 'error' : 'ready'); if (!error) ready(); });
  ready();
})();
